function requireHttpOrigin(variableName) {
  const rawValue = process.env[variableName];

  if (!rawValue) {
    throw new Error(`${variableName} must be configured`);
  }

  let parsed;
  try {
    parsed = new URL(rawValue);
  } catch {
    throw new Error(`${variableName} must be a valid URL origin`);
  }

  if (
    !['http:', 'https:'].includes(parsed.protocol)
    || parsed.username
    || parsed.password
    || parsed.pathname !== '/'
    || parsed.search
    || parsed.hash
  ) {
    throw new Error(`${variableName} must contain only an http(s) origin`);
  }

  return parsed.origin;
}

export const XOMICS_API_ORIGIN = requireHttpOrigin('REACT_APP_XOMICS_API_ORIGIN');
export const CLINIC_API_ORIGIN = requireHttpOrigin('REACT_APP_CLINIC_API_ORIGIN');
export const WEBSERVER_API_ORIGIN = requireHttpOrigin('REACT_APP_WEBSERVER_API_ORIGIN');
